import {
  FILTER_CAT_COMPANY,
  FILTER_CAT_JOB,
  FILTER_CAT_LOCATION,
  FILTER_CAT_SALARY,
} from '../../constants/corePublicTheme';
import { getFilterVisualCategory } from '../../utils/filters/filter-attribute-category';

/** Attributes that must not appear in the desktop top facet bar (only in their dedicated selector, e.g. Last Seen). */
const EXCLUDED_TOP_FILTER_ATTRIBUTES = new Set(['normalisedTitle', 'firstSeenMin']);

/**
 * Category colors for desktop filter bar (aligned with FilterCategoryButtons / TEC-382).
 */
export const TOP_FILTER_CATEGORY_COLORS = {
  location: FILTER_CAT_LOCATION,
  salary: FILTER_CAT_SALARY,
  company: FILTER_CAT_COMPANY,
  job: FILTER_CAT_JOB,
} as const;

/** Excluded (negative filter) pill style - same in all categories. */
export const TOP_FILTER_EXCLUDED_COLOR =
  'bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 border-red-300 dark:border-red-700';

/** "Only this value" (exact-match filter) pill style - same in all categories, distinct from
 * both the category color (normal include) and TOP_FILTER_EXCLUDED_COLOR (negation). */
export const TOP_FILTER_ONLY_COLOR =
  'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border-blue-300 dark:border-blue-700';

/** Inactive SRP facet pill / unknown attribute, neutral elevated surface */
export const FILTER_PILL_NEUTRAL_CLASS =
  'bg-jc-elevated text-jc-ink-secondary border-jc-border';

const UNKNOWN_FILTER_PILL_CLASS = FILTER_PILL_NEUTRAL_CLASS;

export type TopFilterMode = 'include' | 'exclude' | 'only';

export function getTopFilterColorClass(
  attribute: string,
  mode: TopFilterMode
): string {
  if (mode === 'exclude') return TOP_FILTER_EXCLUDED_COLOR;
  if (mode === 'only') return TOP_FILTER_ONLY_COLOR;
  const category = getFilterVisualCategory(attribute);
  return category
    ? TOP_FILTER_CATEGORY_COLORS[category]
    : UNKNOWN_FILTER_PILL_CLASS;
}

/** Order for grouping active facets (matches TopFilters final display order). `regionTags` sits
 * next to `location`, TopFilters only ever populates one of the two per request (TEC-482's
 * dev_enable_new_location_system cookie), never both, so having both here is harmless. */
export const TOP_FILTER_ATTRIBUTE_ORDER = [
  'remoteness',
  'location',
  'regionTags',
  'jobType',
  'normalisedRoleLevel',
  'requiredLanguages',
  'field',
  'peopleManagementTier',
  'companyIndustry',
  'companyId',
] as const;

/** Order for building the raw facet list (matches TopFilters allFacetsRaw). */
export const ALL_TOP_FILTER_ATTRIBUTES_ORDER = [
  'remoteness',
  'location',
  'regionTags',
  'jobType',
  'normalisedRoleLevel',
  'companyIndustry',
  'companyId',
  'requiredLanguages',
  'benefits',
  'skillsAndTechnologies',
  'field',
  'educationLevel',
  'peopleManagementTier',
] as const;

export function shouldIncludeFacetInTopFilters(attribute: string): boolean {
  return !EXCLUDED_TOP_FILTER_ATTRIBUTES.has(attribute);
}








